import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'

export function UIEditorFieldNumber({
  dp = 0,
  min = -Infinity,
  max = Infinity,
  step = 1,
  bigStep = 5,
  smallStep = 1,
  value,
  onChange,
}) {
  const formatNum = (num, dp) => {
    if (isNaN(num)) return '0'
    const rounded = num.toFixed(dp)
    // remove trailing zeros and a trailing decimal if no decimals remain
    return rounded.replace(/(\.\d*?[1-9])0+$|\.0+$/, '$1')
  }
  value = value || 0
  const [local, setLocal] = useState(formatNum(value, dp))
  const [focused, setFocused] = useState(false)
  useEffect(() => {
    if (!focused) {
      if (local !== formatNum(value, dp)) setLocal(formatNum(value, dp))
    }
  }, [focused, value])
  const parseStr = (str, ogValue) => {
    // try parse math
    let num
    try {
      num = (0, eval)(str)
      if (typeof num !== 'number') {
        throw new Error('input number parse fail')
      }
    } catch (err) {
      // console.error(err)
      num = ogValue // revert back to original
    }
    if (num < min || num > max) {
      num = ogValue
    }
    return num
  }
  return (
    <div
      className='fieldnum'
      css={css`
        flex: 1;
        display: flex;
        align-items: center;
        input {
          background: var(--bg4);
          border-radius: 5px;
          padding: 0 12px;
          height: 34px;
          text-align: right;
          overflow: hidden;
          cursor: inherit;
          &::selection {
            background-color: white;
            color: rgba(0, 0, 0, 0.8);
          }
        }
      `}
    >
      <input
        type='text'
        value={local}
        onChange={e => setLocal(e.target.value)}
        onKeyDown={e => {
          if (e.code === 'Enter') {
            e.preventDefault()
            e.target.blur()
          }
          if (e.code === 'ArrowUp') {
            const amount = e.shiftKey ? bigStep : e.altKey ? smallStep : step
            const num = parseStr(value + amount, value)
            setLocal(formatNum(num, dp))
            onChange(+num.toFixed(dp))
          }
          if (e.code === 'ArrowDown') {
            const amount = e.shiftKey ? bigStep : e.altKey ? smallStep : step
            const num = parseStr(value - amount, value)
            setLocal(formatNum(num, dp))
            onChange(+num.toFixed(dp))
          }
        }}
        onFocus={e => {
          setFocused(true)
          e.target.select()
        }}
        onBlur={e => {
          setFocused(false)
          // if blank, set back to original
          if (local === '') {
            setLocal(formatNum(value, dp))
            return
          }
          // otherwise run through pipeline
          const num = parseStr(local)
          const newValue = +num.toFixed(dp)
          if (value === newValue) return // dont trigger onChange if same
          setLocal(formatNum(num, dp))
          onChange(newValue)
        }}
      />
    </div>
  )
}
